import { LeagueBase, RoundBase, SportEventBase, TeamMember } from "@/models";
import { Referee } from "./referee.model";

export interface Match {
  id: number;
  round_id: number;
  start_time: string;
  length: string;
  length_of_halftime: string;
  hometeam: MatchTeam;
  awayteam: MatchTeam;
  status: MatchStatus;
  sportfield_name: string;
  referee_comment: string;
  referees: Referee[];
  event_referees: Referee[];
  event: SportEventBase;
  league: LeagueBase;
  round: RoundBase;
}

export interface MatchTeam {
  id: number;
  name: string;
  display_name: string;
  uniform_color: string;
  uniform_color_hex: string;
  captain_name: string;
  logo_path: string;
  owner_id: number;
  captain_id: number;
  facebook_profile: string;
  goals: number;
  penalty: number | null;
  half_time_goals: number | null;
  best_player: number | null;
  members: MatchTeamMember[];
}

export interface MatchTeamMember extends TeamMember {
  user_id: number;
  goals: number;
}

export interface MatchStatus {
  id: number;
  code: MatchStatusCode;
  name: string;
}

export enum MatchStatusCode {
  NotPlayedYet = "not_played_yet",
  NoMatch = "no_match",
  HomePostpone = "home_postpone",
  AwayPostpone = "away_postpone",
  HomeStayAway = "home_stay_away",
  AwayStayAway = "away_stay_away",
  BothStayAway = "both_stay_away",
  Ok = "ok"
}

export interface EditMatch {
  hometeam_goals?: number;
  awayteam_goals?: number;
  half_time_hometeam_goals?: number;
  half_time_awayteam_goals?: number;
  home_penalty?: number;
  away_penalty?: number;
  away_team_goals?: EditMatchGoalScorer[];
  home_team_goals?: EditMatchGoalScorer[];
  referees?: Referee[];
  referee_comment?: string;
}

export interface EditMatchGoalScorer {
  user_id: number;
  goals: number;
}

export interface BestPlayers {
  home_best_player?: number;
  away_best_player?: number;
}

export interface GoalkeeperRatings {
  hometeam_goalkeeper?: {
    user_id: number;
    rating: number;
  };
  awayteam_goalkeeper?: {
    user_id: number;
    rating: number;
  };
}
